import { combineReducers } from 'redux'
import {
	alertReducers,
	identityReducers,
	LocaleReducer,
	namespaceReducers,
	profileReducers,
	settingsReducers,
	tenantConfigReducer,
	tenantReducers,
	whiteLabelReducers,
} from '../app/common'
import { DashboardReducer } from '../app/common/analytics'
import { EntityListReducer, EntityReducer } from '../app/common/base/entity'
import { reportsReducers } from '../app/reports'
import {
	caseDocumentConfig,
	caseFieldConfig,
	caseMasterListConfig,
	caseNoteConfig,
	caseSectionConfig,
	caseSectionFieldConfig,
	caseUserConfig,
	caseValueConfig,
	relatedCaseConfig,
	scorecardReducers,
	supportCaseDocumentConfig,
	supportCaseFieldConfig,
	supportCaseNoteConfig,
	supportCaseSectionConfig,
	supportCaseSectionFieldConfig,
	supportCaseValueConfig,
} from '../app/ticket-management'

const rootReducer = combineReducers({
	...identityReducers,
	...settingsReducers,
	...alertReducers,
	...tenantReducers,
	...EntityReducer,
	...EntityListReducer,
	...caseValueConfig,
	...caseFieldConfig,
	...caseSectionConfig,
	...caseSectionFieldConfig,
	...caseMasterListConfig,
	...caseNoteConfig,
	...profileReducers,
	...relatedCaseConfig,
	...namespaceReducers,
	...scorecardReducers,
	...DashboardReducer,
	...caseDocumentConfig,
	...caseUserConfig,
	...supportCaseValueConfig,
	...supportCaseFieldConfig,
	...supportCaseSectionConfig,
	...supportCaseSectionFieldConfig,
	...supportCaseNoteConfig,
	...supportCaseDocumentConfig,
	...LocaleReducer,
	...tenantConfigReducer,
	...whiteLabelReducers,
	...reportsReducers,
})

export default rootReducer
